import { Component } from '@angular/core';

@Component({
  selector: 'app-sales-detail',
  standalone: false,
  
  templateUrl: './sales-detail.component.html',
  styles: ``
})
export class SalesDetailComponent {

}
